// Jquery pour le chargement des routes
import 'jquery';

// Dépendances locales
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

const routes = new Router({
    // Sur toutes les pages
    common,
    // Sur la home
    home,
});

// Chargement des évènements
jQuery(document).ready(() => routes.loadEvents());
